<template>
  <section class="purchases purchases--lk">
    <app-loading :is-loading="isLoading" />
    <template v-if="lotDetail.general">
      <div class="container">
        <div
          v-if="lotDetail.general"
          class="row"
        >
          <div class="col-12">
            <div class="purchases__title-wrapper">
              <h2 class="purchases__title">
                {{ title }}
              </h2>
              <div class="row">
                <div class="col-9">
                  <div class="purchases__form purchases__form--disabled">
                    <div class="purchases__form-title-wrapper">
                      <h3 class="purchases__form-title">
                        {{ lotDetail.general.title }}
                      </h3>
                    </div>
                    <DetailsSectionCommon
                      v-for="item in lotDetail.general.items"
                      :key="item.name"
                      :data="item"
                    />
                  </div>
                </div>
                <div class="col-3">
                  <div
                    v-if="requestDatetimeEnd"
                    class="purchases__timers-wrapper"
                  >
                    <p class="purchases__timers-text">
                      До окончания подачи заявки осталось:
                    </p>
                    <p class="purchases__timers-time">
                      {{ requestDatetimeEnd }}
                    </p>
                  </div>
                  <div
                    v-if="applicationDate"
                    class="purchases__timers-wrapper"
                  >
                    <p class="purchases__timers-text">
                      До повторной подачи КП осталось:
                    </p>
                    <p class="purchases__timers-time purchases__timers-time--green">
                      {{ applicationDate }}
                    </p>
                  </div>
                  <div
                    v-if="criterionScore > 0"
                    class="purchases__timers-wrapper"
                  >
                    <p class="purchases__timers-text">
                      Итоговый рейтинг (балл, присвоенный участнику):
                    </p>
                    <p class="purchases__timers-time purchases__timers-time--dark-green">
                      {{ criterionScore }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="comments"
          class="row"
        >
          <div class="col-12">
            <div class="purchases__form-title-wrapper">
              <h3 class="purchases__form-title">
                {{ comments.title }}
              </h3>
            </div>
            <div class="purchases__form-block">
              <div class="row">
                <div class="col-12">
                  <table class="purchases__table">
                    <colgroup>
                      <col style="width: 25%">
                      <col style="width: 30%">
                      <col style="width: 45%">
                    </colgroup>
                    <thead class="purchases__thead">
                      <tr>
                        <th>
                          Дата и время изменения
                        </th>
                        <th>
                          Ответственное лицо
                        </th>
                        <th>
                          Событие
                        </th>
                      </tr>
                    </thead>
                    <tbody class="purchases__tbody">
                      <tr
                        v-for="(item,index) in comments.items"
                        :key="`${item.value}-${index}`"
                        class="purchases__tbody-row"
                      >
                        <td class="purchases__tbody-column">
                          {{ item.title }}
                        </td>
                        <td class="purchases__tbody-column">
                          {{ item.name }}
                        </td>
                        <td class="purchases__tbody-column">
                          {{ item.value }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="docsTemplates.items.length > 0"
          class="row"
        >
          <div class="col-12">
            <div class="purchases__form purchases__form--disabled">
              <div class="purchases__form-title-wrapper">
                <h3 class="purchases__form-title">
                  {{ docsTemplates.title }}
                </h3>
              </div>
              <div class="purchases__form-block">
                <div class="row">
                  <div class="col-12">
                    <table class="purchases__table">
                      <thead class="purchases__thead">
                        <tr>
                          <th
                            v-for="column in docsTemplates.titles"
                            :key="column.name"
                          >
                            {{ column.title }}
                          </th>
                        </tr>
                      </thead>
                      <tbody class="purchases__tbody">
                        <DetailsSectionDocs
                          v-for="item in docsTemplates.items"
                          :key="item.name"
                          disabled
                          :data="item"
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="purchases__form">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="purchases__form-title-wrapper">
                  <h3 class="purchases__form-title">
                    {{ offer.title }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="purchases__form-block">
              <div class="row">
                <div class="col-12">
                  <DeliverGoodsTable
                    :disabled="!canSendOffer"
                    :offers="supplierOffers"
                    :titles="offer.titles"
                    :items="offer.items"
                    :page-number="currentPage"
                    :criterion-description="criterionDescription"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        v-if="pageCount > 1"
        :pages="pageCount"
        :current-page="currentPage"
        @clickPage="clickPage"
      />

      <div
        v-if="hasRole('supplier')"
        style="margin: 20px 10px 100px 0; text-align: right"
      >
        <ButtonForm
          label="Скачать перечень"
          style="min-width: 400px"
          @click="downloadNomenclature"
        />
      </div>

      <div
        v-if="hasRole('supplier')"
        class="container"
      >
        <div class="purchases__form purchases__form--summa purchases__form--disabled">
          <div class="row">
            <div class="col-12 col-md-5">
              <h2 class="purchases__title-subtitle">
                Сумма вашего предложения
              </h2>
            </div>
            <div class="col-12 col-md-7 d-flex flex-column align-items-center">
              <InputForm
                input-class="purchases__form-input purchases__form-input--blue"
                :value="offerSum"
                type="number"
                is-price
                disabled
                style="width: 100%"
              />
              <p
                v-if="isExpensive"
                class="purchases__text-hint"
              >
                Отклонение от лучшего предложения 10%
              </p>
            </div>
          </div>
        </div>
        <div
          v-if="lotDetail.supplier"
          class="purchases__form purchases__form--disabled"
        >
          <div class="purchases__form-title-wrapper">
            <h3 class="purchases__form-title">
              {{ lotDetail.supplier.title }}
            </h3>
          </div>
          <DetailsSectionCommon
            v-for="item in lotDetail.supplier.items"
            :key="item.name"
            :data="item"
          />
        </div>

        <div class="purchases__form">
          <div class="row">
            <div class="col-12">
              <div class="purchases__form-title-wrapper">
                <h3 class="purchases__form-title">
                  Производитель предлагаемого материала
                </h3>
              </div>
              <div class="purchases__form-block purchases__form-block-check">
                <InputForm
                  v-model:value="materialManufacturer"
                  placeholder="Введите наименование производителя предлагаемого материала"
                  input-class="purchases__form-input purchases__form-inputPrice"
                />
                <div class="purchases__hint purchases__hint--hide purchases__hint--margin">
                  Обязательное поле для заполнения
                </div>
              </div>
            </div>
          </div>
        </div>

        <div :class="showFixDate ? 'purchases__form-grid' : ''">
          <div class="purchases__form">
            <div class="row">
              <div class="col-12">
                <div class="purchases__form-title-wrapper">
                  <h3 class="purchases__form-title">
                    Фиксация цены
                  </h3>
                </div>
                <div class="purchases__form-block purchases__form-block-check">
                  <SimpleSelect
                    id="fix-price"
                    :options="fixPriceOptions"
                    :default="fixCostDefault"
                    @updated="onFixPriceUpdated"
                  />

                  <div class="purchases__hint purchases__hint--hide purchases__hint--margin">
                    Обязательное поле для заполнения
                  </div>
                </div>
              </div>
            </div>

            <HintBlock
              v-if="criterionDescription && criterionDescription.fixPrice"
              class="purchases__form__hint-block"
            >
              <span v-html="criterionDescription.fixPrice" />
            </HintBlock>
          </div>

          <div
            v-if="showFixDate"
            class="purchases__form"
          >
            <div class="row">
              <div class="col-12">
                <div class="purchases__form-title-wrapper">
                  <h3 class="purchases__form-title">
                    Цена зафиксирована до
                  </h3>
                </div>
                <div class="purchases__form-block purchases__form-block-check">
                  <InputForm
                    v-model:value="fixCostEndDate"
                    placeholder="Дата окончания фиксации"
                    input-class="purchases__form-input purchases__form-inputPrice"
                    type="date"
                  />

                  <div
                    :class="{'purchases__hint--hide': !fixCostEndDateError}"
                    class="purchases__hint purchases__hint--margin"
                  >
                    Обязательное поле для заполнения
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="purchases__form">
          <div class="row">
            <div class="col-12">
              <div class="purchases__form-title-wrapper">
                <h3 class="purchases__form-title">
                  Размер аванса в (%)
                </h3>
              </div>
              <div class="purchases__form-block purchases__form-block-check">
                <InputForm
                  v-model:value="deliveryCondition"
                  placeholder="Введите размер аванса"
                  input-class="purchases__form-input purchases__form-inputPrice text-right purchases__form-input--green-text"
                  type="number"
                  postfix="%"
                  :max-number-value="100"
                />
                <div class="purchases__hint purchases__hint--hide purchases__hint--margin">
                  Обязательное поле для заполнения
                </div>
              </div>
            </div>
          </div>

          <HintBlock
            v-if="criterionDescription && criterionDescription.prepaidExpense"
            class="purchases__form__hint-block"
          >
            <span v-html="criterionDescription.prepaidExpense" />
          </HintBlock>
        </div>

        <div class="purchases__form">
          <div class="row">
            <div class="col-12">
              <div class="purchases__form-title-wrapper">
                <h3 class="purchases__form-title">
                  Опыт работы
                </h3>
              </div>
              <div class="purchases__form-block purchases__form-block-check">
                <label class="purchases__checkbox-wrapper purchases__checkbox-wrapper--request">
                  <input
                    v-model="experience"
                    class="purchases__checkbox-input"
                    type="checkbox"
                    name="check"
                  >
                  <span class="purchases__checkbox-span" />
                  <span class="purchases__checkbox-title">
                    Наличие опыта работы на объектах компании
                  </span>
                </label>
              </div>
            </div>
          </div>

          <HintBlock
            v-if="criterionDescription && criterionDescription.experience"
            class="purchases__form__hint-block"
          >
            <span v-html="criterionDescription.experience" />
          </HintBlock>
        </div>

        <div class="purchases__form">
          <div class="row">
            <div class="col-12">
              <div class="purchases__form-title-wrapper">
                <h3 class="purchases__form-title">
                  Согласие с текущей формой договора
                </h3>
              </div>
              <div class="purchases__form-block purchases__form-block-check">
                <SimpleSelect
                  id="fix-price"
                  :options="approveOptions"
                  :default="consentContract ? 'Да' : 'Нет'"
                  @updated="onConsentContractUpdated"
                />

                <div class="purchases__hint purchases__hint--hide purchases__hint--margin">
                  Обязательное поле для заполнения
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="purchases__form">
          <div class="row">
            <div class="col-12">
              <div class="purchases__form-title-wrapper">
                <h3 class="purchases__form-title">
                  Стоимость доставки
                </h3>
              </div>
              <div class="purchases__form-block purchases__form-block-check">
                <input
                  v-model="deliverySum"
                  type="text"
                  name="cost-of-delivery"
                  class="purchases__form-input"
                  :disabled="!canSendOffer"
                  placeholder="Введите стоимость доставки в свободной форме"
                  required
                >
                <div class="purchases__hint purchases__hint--hide purchases__hint--margin">
                  Обязательное поле для заполнения
                </div>
              </div>
            </div>
          </div>
        </div>
        <Files
          v-model:files="files"
          v-model:old-files="oldFiles"
          title="Коммерческое предложение"
          :disabled="!canSendOffer"
        />
        <div class="purchases__form">
          <div class="row">
            <div class="col-12">
              <div class="purchases__form-title-wrapper">
                <h3 class="purchases__form-title">
                  Дополнительная информация
                </h3>
              </div>
              <div class="purchases__form-block">
                <div class="row">
                  <div class="col-12">
                    <textarea
                      v-model="additionalInfo"
                      class="purchases__textarea purchases__textarea--limit"
                      placeholder="Введите текст"
                      :disabled="!canSendOffer"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ErrorForm
          v-if="filesError"
          :message="filesError"
        />
      </div>

      <div class="container">
        <ErrorForm
          v-if="fixCostEndDateError"
          :message="fixCostEndDateError"
        />
        <ErrorForm
          v-if="materialManufacturerError"
          :message="materialManufacturerError"
        />
      </div>

      <div class="purchases__form-buttons purchases__form-buttons--mt row row--end">
        <div class="col-12 col-md-4 col-xl-3">
          <button
            v-if="canSendOffer && isNotCustomer"
            class="purchases__button"
            @click="sendOffer"
          >
            Подать заявку
          </button>
        </div>
        <div class="col-12 col-md-4 col-xl-3">
          <router-link
            v-slot="{ navigate }"
            :to="{ name: 'ActualPurchases' }"
            custom
          >
            <button
              type="button"
              class="purchases__button purchases__button--white"
              role="link"
              @click="navigate"
              @keypress.enter="navigate"
            >
              Вернуться к закупкам
            </button>
          </router-link>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import dayjs from 'dayjs';
import api from '@/api';
import DetailsSectionCommon from '@/components/details/DetailsSectionCommon.vue';
import DeliverGoodsTable from '@/components/details/DeliverGoodsTable.vue';
import Pagination from '@/components/elements/Pagination.vue';
import Files from '@/components/blocks/Files';
import ErrorForm from '@/components/form/error-form.vue';
import { dateFormat, declOfNum } from '@/utils/helpers';
import DetailsSectionDocs from '@/components/details/DetailsSectionDocs.vue';
import SimpleSelect from '@/components/elements/SimpleSelect.vue';
import HintBlock from '@/components/blocks/HintBlock.vue';
import InputForm from '@/components/form/input-form.vue';
import ButtonForm from '@/components/form/button-form.vue';
import FileDownload from 'js-file-download';

export default {
  name: 'Request',
  components: {
    InputForm,
    DetailsSectionDocs,
    DetailsSectionCommon,
    Files,
    DeliverGoodsTable,
    Pagination,
    ErrorForm,
    SimpleSelect,
    HintBlock,
    ButtonForm,
  },
  data() {
    return {
      lotID: null,
      files: [],
      oldFiles: [],
      isLoading: true,
      editableSections: {},
      currentPage: 1,
      supplierOffers: null,
      deliverySum: '',
      additionalInfo: '',
      applicationDate: '',
      filesError: '',
      fixCost: 'none',
      fixCostDefault: 'Отсутствует',
      deliveryCondition: 0,
      materialManufacturer: '',
      fixCostEndDate: '',
      experience: false,
      consentContract: true,
      criterionScore: null,
      criterionDescription: {},
      comments: null,
      fixCostEndDateError: '',
      materialManufacturerError: '',
    };
  },
  created() {
    this.lotID = this.$route.params.lotID;
  },
  async mounted() {
    await this.loadInfo();
    await this._loadLotDetail();
    this.calcApplicationDate();
    setInterval(() => this.calcApplicationDate(), 5000);
  },
  computed: {
    ...mapState({
      lotDetail: (state) => state.lots.lotDetail,
      dynamicServerTime: (state) => state.user.dynamicServerTime,
    }),
    ...mapGetters({
      hasRole: 'user/hasRole',
    }),

    isNotCustomer() {
      return !this.hasRole('customer');
    },

    fixPriceOptions() {
      return [
        { key: 'full', title: 'Полная' },
        { key: 'partial', title: 'Частичная' },
        { key: 'none', title: 'Отсутствует' },
      ];
    },

    approveOptions() {
      return [
        { key: true, title: 'Да' },
        { key: false, title: 'Нет' },
      ];
    },

    showFixDate() {
      return ['full', 'partial'].includes(this.fixCost);
    },

    docsTemplates() {
      const templates = this.lotDetail.documentTemplates;
      if (!templates) {
        return {
          items: [],
        };
      }
      const columnsOrder = {
        title: 0,
        file: 1,
        dateTime: 2,
        link: 3,
      };
      const result = { ...templates };
      result.titles.sort((a, b) => columnsOrder[a.name] - columnsOrder[b.name]);
      return result;
    },
    offerSum() {
      if (!this.supplierOffers) {
        return 0;
      }
      return Object.values(this.supplierOffers)
        .reduce((sum, item) => sum + item.sum, 0);
    },
    pageCount() {
      return this.offer.items ? Math.ceil(this.offer.items.length / 10) : 0;
    },
    canSendOffer() {
      return this.requestDatetimeEnd && !this.applicationDate;
    },
    offer() {
      return this.lotDetail.offerItems || {};
    },
    isExpensive() {
      return !!this.offer.lot?.isExpensive;
    },
    isSubmitBtnDisabled() {
      return !this.files.length;
    },
    requestDatetimeEnd() {
      if (!this.lotDetail) {
        return '';
      }
      const dateValue = this.lotDetail.recieveRequest.items.find((item) => item.name === 'requestDatetimeEnd').value;
      if (!dateValue) {
        return '';
      }
      const date = dayjs(dateValue);
      if (date.diff(dayjs()) < 0) {
        return '';
      }
      return date.fromNow(true);
    },
    title() {
      const number = (
        this.lotDetail.general?.items?.find((item) => item.name === 'purchaseNumber') || {}
      ).value;
      return `Заявка на участие в закупке №${number}`;
    },
  },
  methods: {
    ...mapActions({
      loadInfo: 'user/loadInfo',
      loadLotDetail: 'lots/loadLotDetail',
      supplyOffer: 'lots/supplyOffer',
    }),
    calcApplicationDate() {
      if (!this.offer.lot?.applicationDate) {
        this.applicationDate = '';
        return;
      }
      const date = dayjs(this.offer.lot.applicationDate);
      const diff = Math.abs(date.diff(dayjs(this.dynamicServerTime), 'minute'));

      if (diff < 1) {
        this.applicationDate = '';
        return;
      }

      const hours = parseInt(diff / 60, 10);
      const minutes = diff - (60 * hours);

      const res = [];

      if (hours) {
        res.push(`${hours} ${declOfNum(hours, ['час', 'часа', 'часов'])}`);
      }

      if (minutes) {
        res.push(`${minutes} ${declOfNum(minutes, ['минута', 'минуты', 'минут'])}`);
      }

      this.applicationDate = res.join(' ');
    },
    async _loadLotDetail() {
      await this.loadLotDetail({ id: this.lotID });
      this.isLoading = false;
      if (!this.offer.items) {
        return;
      }

      this.additionalInfo = this.offer.lot.additionalInfo;
      this.deliverySum = this.offer.lot.deliverySum;
      this.deliveryCondition = this.offer.lot.deliveryCondition;
      this.materialManufacturer = this.offer.lot.materialManufacturer;
      this.fixCostEndDate = this.offer.lot.fixCostEndDate;
      this.experience = this.offer.lot.experience;
      this.consentContract = this.offer.lot.consentContract;
      this.fixCost = this.offer?.lot?.fixCost || 'none';
      this.criterionScore = this.offer.lot.criterionScore;
      this.criterionDescription = this.lotDetail?.criterionDescription || {};
      const option = this.fixPriceOptions.find((priceOption) => priceOption.key === this.fixCost);
      this.fixCostDefault = option ? option.title : 'Отсутствует';

      if (this.lotDetail?.comments?.items?.length) {
        this.comments = this.lotDetail?.comments;
      } else {
        this.comments = null;
      }

      this.files = [];
      this.oldFiles = this.offer.lot.files;
      this.supplierOffers = {};
      this.offer.items.forEach((item) => {
        const offer = item.offer || {
          ...item,
          deliveryDateEnd: item.deliveryPeriodEnd,
          deliveryDateStart: item.deliveryPeriodStart,
          itemAnalogGuid: '',
          price: null,
        };
        this.supplierOffers[item.id] = {
          lotItemId: item.id,
          haveAnalog: offer.haveAnalog,
          itemAnalogGuid: offer.itemAnalogGuid,
          quantity: offer.quantity,
          unit: offer.unit,
          price: offer.price,
          sum: offer.price * offer.quantity,
          deliveryDate: offer.deliveryDate,
          deliveryDateEnd: dateFormat(offer.deliveryDateEnd),
          deliveryDateStart: dateFormat(offer.deliveryDateStart),
          guaranteeDate: offer.guaranteeDate,
          deliveryCondition: offer.deliveryCondition,
          materialManufacturer: offer.materialManufacturer,
          fixCostEndDate: offer.fixCostEndDate,
          guarantee: offer.guarantee,
          haveVAT: offer.haveVAT,
          fixCost: offer.fixCost || false,
        };
      });
    },
    setSectionEditedState(sectionId, isTrue) {
      this.editableSections[sectionId] = isTrue;
    },
    clickPage(number) {
      this.currentPage = Number(number);
    },
    onFixPriceUpdated({ changed }) {
      this.fixCost = changed.value.key;
    },
    onConsentContractUpdated({ changed }) {
      this.consentContract = changed.value.key;
    },
    async sendOffer() {
      this.filesError = '';
      this.fixCostEndDateError = '';
      this.materialManufacturerError = '';

      if (!this.files.length && !this.oldFiles.length) {
        this.filesError = 'Необходимо прикрепить коммерческое предложение';
        return;
      }

      if (!this.materialManufacturer) {
        this.materialManufacturerError = 'Необходимо заполнить производителя предлагаемого материала';
        return;
      }

      if (this.showFixDate && !this.fixCostEndDate) {
        this.fixCostEndDateError = 'Необходимо указать дату окончания зафиксированной цены';
        return;
      }

      try {
        this.isLoading = true;

        await this.supplyOffer({
          lotId: this.lotID,
          offerId: this.offer.lot.offerId,
          deliverySum: this.deliverySum,
          fixCost: this.fixCost,
          deliveryCondition: this.deliveryCondition,
          materialManufacturer: this.materialManufacturer,
          fixCostEndDate: this.fixCostEndDate,
          additionalInfo: this.additionalInfo,
          items: Object.values(this.supplierOffers)
            .filter(((item) => !!item.price)).map((item) => ({ ...item, guaranteeId: item.guarantee.id })),
          tmpFiles: this.files.map((file) => file.id),
          oldFiles: this.oldFiles?.map((file) => file.id) ?? [],
          experience: this.experience,
          consentContract: this.consentContract,
        });
        await this._loadLotDetail();

        this.$router.push({
          name: 'SuccessRequest',
          query: {
            lotId: this.lotID,
          },
        });
      } catch (e) {
        console.log(e);
        alert(e.response.data.description);
        this.isLoading = false;
      }
    },

    async downloadNomenclature() {
      this.isLoading = true;

      try {
        const response = await api.lots.supplier.downloadLotNomenclature(this.lotID);
        FileDownload(response.data, 'lot_nomenclature.xls');
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.row--end {
  justify-content: flex-end;
}

.purchases__form__hint-block {
  margin-top: 20px;
}

.purchases__form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 40px;

  & div:first-child {
    margin-top: 0;
  }
}
</style>
